import React from 'react';

import { Card, CardContent, CardHeader, Feed, FeedEvent, FeedContent, FeedSummary, FeedDate, FeedExtra } from 'semantic-ui-react'

export function LocationCard(props) {
  let color = 'orange';
  let index = props.location.location_id % 7;
  if(index === 1) { color = 'teal'; }
  if(index === 2) { color = 'purple'; }
  if(index === 3) { color = 'green'; }
  if(index === 4) { color = 'yellow'; }
  if(index === 5) { color = 'red'; }
  if(index === 6) { color = 'pink'; }

  let width = 290;

  return (
    <Card key={props.location.location_id}
      color={color}
      style={{width: width + 'px'}}
    >
      <CardContent>
        <CardHeader>{props.location.name}</CardHeader>
        <div className="card_feeds">
          <Feed>
            {props.location.concerts.map(function(concert) {
              let date_formatted = new Date(concert.date).toLocaleDateString("en-GB", { weekday: "long", year: "numeric", month: "long", day: "numeric",});
              return <FeedEvent key={concert.concert_id}>
                <FeedContent>
                  <FeedSummary>
                    {concert.act && 
                      <><a href={'/act/' + concert.act.act_id} key={concert.act.act_id}>{concert.act.name}</a>
                      {concert.act2 && 
                        <>, <a href={'/act/' + concert.act2.act_id} key={concert.act2.act_id}>{concert.act2.name}</a></>
                      }
                      : </>
                    }
                    {concert.artists && concert.artists.map(function(artist, i) {
                      return <>{i > 0 && <>, </>}<a href={'/artist/' + artist.artist_id} key={artist.artist_id}>{'first_name' in artist && <>{artist.first_name} </>}{artist.last_name}</a></>
                    })}
                  </FeedSummary>
                  {concert['accompaniments'] && 
                    <FeedDate>
                      with {concert['accompaniments'].map(function(accompaniment, i) {
                        return <>{i > 0 && <>, </>}{accompaniment.name} ({accompaniment.role})</>
                      })}
                    </FeedDate>
                  }
                  {concert.show && 
                    <FeedDate>
                      {concert.show.name}
                    </FeedDate>
                  }
                  {concert.festival && 
                    <FeedDate>
                      {concert.festival.name}
                    </FeedDate>
                  }
                  <FeedExtra>{date_formatted} {concert.time !== '' && <>{' @ ' + concert.time}</>}</FeedExtra>
                </FeedContent>
              </FeedEvent>
            })}
          </Feed>
        </div>
        {props.location.concerts.length === 0 &&
          <div style={{ textAlign: 'center', marginTop: '10px' }}>
            <p>No concerts found</p>
          </div>
        }
      </CardContent>
    </Card>
  );
}